"use client";

import { Button, HStack, VStack } from "@chakra-ui/react";
import usePageSearch from "../hooks/usePageSearch";
import NavbarSearchControls from "./NavbarSearchControls";
import GenericDrawerInfo from "@/shared/ui/display/GenericDrawerInfo";
import GenericIcon from "@/shared/ui/actions/GenericIcon";
import { iconSizePresets } from "@/shared/config/iconSizePresets";

export default function SearchFilters() {
  const {
    searchControls,
    hasNonDefaultSearchAdjustments,
    searchScopeLabel,
  } = usePageSearch();

  return (
    <VStack spaceY="3" align="stretch">
      <GenericDrawerInfo
        description={`Tune how search behaves for the current ${searchScopeLabel} view.`}
        items={[
          {
            label: hasNonDefaultSearchAdjustments
              ? "Custom filters active"
              : "Default filters",
            colorPalette: hasNonDefaultSearchAdjustments ? "blue" : "gray",
          },
        ]}
      />

      <HStack justify="flex-end">
        <Button
          variant="ghost"
          onClick={() => searchControls.resetSearchAdjustments()}
          disabled={!hasNonDefaultSearchAdjustments}
        >
          <GenericIcon
            icon="reset"
            size={iconSizePresets.actionButton}
            highlighted={hasNonDefaultSearchAdjustments}
            humanReadable="Reset filters"
          />
        </Button>
      </HStack>

      <NavbarSearchControls />
    </VStack>
  );
}
